import { IForm } from 'core-components/classes/models/IForm'
import {
  IAdditionalFields,
  onDefaultCheck,
  onWithChildrenCheck,
} from 'core-components/library/list/helpers'
import { ICheckedValue } from 'core-components/library/list/types'

export const calculateDefaultChecked = (
  items: IForm[],
  keyField: string,
  checkedValues: ICheckedValue[]
) => {
  const checked = checkedValues.filter((checkedValue) => {
    return checkedValue.value === 'full'
  })
  return checked.map((checkedValue) => {
    const foundItem = items.find((item) => item[keyField] === checkedValue.key)
    if (foundItem) {
      return foundItem[keyField]
    }
    return ''
  })
}

export const calculateWithChildrenChecked = (
  items: IForm[],
  hierarchyField: string | undefined,
  keyField: string,
  newCheckedValues: ICheckedValue[]
) => {
  const deepChildren = items.filter((item) => hierarchyField && !item[hierarchyField])
  const deepChildrenIds = deepChildren.map((item) => item[keyField])
  const filteredCheckedValues = newCheckedValues.filter((checkedValue) => {
    return deepChildrenIds.includes(checkedValue.key) && checkedValue.value === 'full'
  })
  return filteredCheckedValues.map((checkedValue) =>
    deepChildren.find((item) => item[keyField] === checkedValue.key)![keyField]
  )
}

export const recalculateDefaultTypeValues = (
  item: IForm | IForm[],
  value: boolean,
  items: IForm[],
  additionalFields: IAdditionalFields
) => {
  const newCheckedValues = onDefaultCheck(item, value, items, additionalFields)
  return calculateDefaultChecked(items, additionalFields.fields.keyField, newCheckedValues)
}

export const recalculateWithChildrenValues = (
  item: IForm | IForm[],
  value: boolean,
  items: IForm[],
  additionalFields: IAdditionalFields,
  filterHierarchyField: string | undefined
) => {
  const newCheckedValues = onWithChildrenCheck(item, value, items, additionalFields)
  return calculateWithChildrenChecked(
    items,
    filterHierarchyField,
    additionalFields.fields.keyField,
    newCheckedValues
  )
}

export const updateCheckedValues = (
  selectedItems: IForm[],
  items: IForm[],
  additionalFields: IAdditionalFields
) => {
  return onWithChildrenCheck(selectedItems, true, items, additionalFields)
}
